import axios from 'axios';

const updateAppointmentStatus = (id, status) =>
  axios
    .post(`${process.env.REACT_APP_API_URL}/api/appointment/${id}/status`, { status })
    .then(res => res)
    .catch(err => err);

export default updateAppointmentStatus;
